// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import ElementUI from "element-ui";
import "./styles/libs/index.css";
import "element-ui/lib/theme-chalk/display.css";
import App from "./App";
import router from "./router";
import store from "./store";
import i18n from "./lang";
import qs from "qs";
import md5 from "js-md5";

Vue.config.productionTip = false;
/* 引入element-ui，指定尺寸以及弹窗的默认z-index */
Vue.use(ElementUI, {
  size: "small",
  zIndex: 3000,
  i18n: (key, args) => i18n.t(key, args)
});


/* 支持全局事件 */
const bus = new Vue();
Vue.prototype.$bus = bus;
Vue.prototype.$qs = qs;
Vue.prototype.$md5 = md5;
Vue.prototype.$extend = function() {
  return Object.assign({}, ...arguments);
};

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  i18n,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js